// Flight plan written as text with no flight line.

import React from 'react';
import style from './flightPlanTrack.module.scss';
import classNames from 'classnames';
import { AirportNode, Node } from 'acscp/components/legs/flightPlan/flightPlanNodes';
import { getArrivalLocation, Leg, locationMatch } from 'acscp/store';

export interface TextOnlyFlightPlanProps {
    legs: Leg[];
    withLogo?: boolean;
}

export class TextOnlyFlightPlan extends React.Component<TextOnlyFlightPlanProps> {

    render(): JSX.Element {
        const nodes = this.parseLegsIntoNodes();

        return(
            <div className={classNames(style.TextOnlyTrack, {[style.WithLogo]: this.props.withLogo})}>
                {nodes.map((node: Node, index: number) => node.renderTextNode(index))}
            </div>
        );
    }

    parseLegsIntoNodes(): AirportNode[] {
        const { legs } = this.props;
        const nodes = new Array<AirportNode>();

        for (let i = 0; i < legs.length; i++) {
            const departure = new AirportNode(legs[i].departureLocation, legs[i].departureAirportId);

            // Add departure only for the first leg OR if the previous leg arrives at a different location
            if (i === 0) {
                nodes.push(departure);
            } else {
                const previousArrival = getArrivalLocation(legs[i - 1]);

                if (!locationMatch(previousArrival, departure)) {
                    nodes.push(departure);
                }
            }

            const arrival = new AirportNode(legs[i].arrivalLocation, legs[i].arrivalAirportId);
            nodes.push(arrival);
        }
        return nodes;
    }
}
